<template>
  <div
    class="mc-liveview__map"
  >
    <VideoList ref="videoList" />
  </div>
</template>

<script>
import VideoList from "./Video/VideoList";

export default {
  name: "TrackerVideo",
  components: {
    VideoList,
  },
};
</script>
